export const SEGMENT_EDITIONS = ["ca2-0", "ca-adoption", "Nevada"];
export const HIGHER_GRADE_LEVELS_REG_EXP = /10|11|12|[6-9]/;
export const MENU_ITEM_MARGIN = 16;
